<div class="dialog-container">
  <h2 mat-dialog-title>
    <mat-icon color="warn">warning</mat-icon>
    {{data.title}}
  </h2>

  <mat-dialog-content>
    <p class="confirmation-message">{{data.message}}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      <mat-icon>cancel</mat-icon>
      {{data.cancelText || 'Cancel'}}
    </button>
    <button mat-raised-button color="warn" (click)="onConfirm()">
      <mat-icon>delete</mat-icon>
      {{data.confirmText || 'Delete'}}
    </button>
  </mat-dialog-actions>
</div>
